import apiClient from '../apiClient';
import { GET_TEMPLATE_EXCURSION_OBJECT_DATA_URL } from '../apiUrl';

const getTemplateExcursionObjectApi = () => {
  return apiClient.get(GET_TEMPLATE_EXCURSION_OBJECT_DATA_URL);
};

export default getTemplateExcursionObjectApi;
